import { format } from "date-fns";
import { cn } from "@/lib/utils";

interface ScheduleGridHeaderProps {
  timeSlots: Date[];
}

export function ScheduleGridHeader({ timeSlots }: ScheduleGridHeaderProps) {
  return (
    <div
      className="grid border-b border-border"
      style={{
        gridTemplateColumns: `80px repeat(${timeSlots.length}, 1fr)`,
        minWidth: `${80 + timeSlots.length * 22}px`,
      }}
    >
      <div className="px-2 py-1 text-[10px] font-medium text-muted-foreground flex items-end sticky left-0 z-10 bg-background">
        Bana
      </div>
      {timeSlots.map((slot, slotIdx) => {
        const isFullHour = slot.getMinutes() === 0;
        return (
          <div
            key={slot.toISOString()}
            className={cn(
              "border-l px-0.5 text-center flex items-end justify-center pb-0.5",
              isFullHour
                ? "border-border text-[10px] font-medium text-muted-foreground"
                : "border-border/20",
            )}
            style={{ gridColumn: slotIdx + 2 }}
          >
            {/* FIX #7: Only show hour number, not :00 */}
            {isFullHour ? format(slot, "HH") : ""}
          </div>
        );
      })}
    </div>
  );
}
